import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useToast = (closeHandler?: () => void) => {
  const showSuccess = (message: string) => {
    toast.success(message, {
      onClose: () => onClose(),
      className: "toastSuccessContainer",
    });
  };

  const showError = (message: string) => {
    toast.error(message, {
      onClose: () => onClose(),
    });
  };

  function showConfirmationAlert(
    message: string,
    onConfirm: () => void,
    onAbort: () => void
  ) {
    if (window.confirm(message)) onConfirm();
    else onAbort();
  }

  function onClose() {
    if (closeHandler) closeHandler();
  }

  return {
    showSuccess,
    showError,
    showConfirmationAlert,
  };
};

export default useToast;
